import { apiClient, assertOk } from "@/api/generated/client"

import type { BalanceRegionTripDays } from "../types/balanceMapTypes"

export const getBalanceRegionTrips = async (id: number): Promise<BalanceRegionTripDays> => {
  const [todayResult, tomorrowResult] = await Promise.all([
    apiClient.GET(`/api/ForHire/balance-regions/trips/{id}`, { params: { path: { id } } }),
    apiClient.GET("/api/ForHire/balance-regions/trips/{id}", {
      params: { path: { id }, query: { tomorrow: true } },
    }),
  ])
  const todayResponse = assertOk(todayResult.response, todayResult.error, todayResult.data)
  const tomorrowResponse = assertOk(
    tomorrowResult.response,
    tomorrowResult.error,
    tomorrowResult.data,
  )

  return { today: todayResponse, tomorrow: tomorrowResponse }
}
